import React, { useEffect } from 'react';
import {
  ClaimsTrackingIcon,
  BuzonIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/help';
import { navigate } from 'gatsby';
import {
  OtherClaimsContainerStyled,
  BoxButtonContainerStyled as BoxButtonContainer,
  BoxStyled,
  InfoBoxStyled,
  ChevronIconContainerStyled as ChevronIconContainer,
  ChevronStyled as ChevronIcon,
  SadIconStyled as SadIcon,
  ClaimsTrackingStyled as ClaimsTracking,
} from './styles/OtherClaimsStyled';
import ButtonBox from '../helpers/ButtonBox';
import { useGlobalData } from '../../../contextProvider/GlobalDataContext';
import { GoogleTagManager } from '../../../helpers';

const OtherClaims = () => {
  const { 'seguimiento-reclamos': claimsTracking = {} } = useGlobalData();
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda/otros-reclamos',
      pageName: 'Ayuda - Otros Reclamos',
    });
  }, []);
  return (
    <OtherClaimsContainerStyled showClaimsTracking={claimsTracking.mostrar}>
      {claimsTracking.mostrar && (
        <ClaimsTracking>
          <ButtonBox
            buttonColor="corporate"
            buttonText="VER RECLAMOS"
            variantButton="outlined"
            urlRedirect="url"
            title="Seguimiento de reclamos"
            icon={<ClaimsTrackingIcon />}
            text="Si realizaste algún reclamo por compra de productos o contratación de servicios, revisa aquí su estado"
          />
        </ClaimsTracking>
      )}
      <BoxButtonContainer>
        <BoxStyled
          onClick={() => {
            navigate('/contacto/reclamos');
          }}
        >
          <BuzonIcon />
          <InfoBoxStyled>
            <h1>Formulario de reclamos</h1>
            <p>Reporta problemas con tus servicios contratados</p>
          </InfoBoxStyled>
          <ChevronIconContainer>
            <ChevronIcon />
          </ChevronIconContainer>
        </BoxStyled>

        <BoxStyled
          onClick={() => {
            navigate('/contacto/baja-voluntaria');
          }}
        >
          <SadIcon />
          <InfoBoxStyled>
            <h1>Baja voluntaria</h1>
            <p>Solicita dar de baja tu servicio de telefonía móvil</p>
          </InfoBoxStyled>
          <ChevronIconContainer>
            <ChevronIcon />
          </ChevronIconContainer>
        </BoxStyled>
      </BoxButtonContainer>
    </OtherClaimsContainerStyled>
  );
};

export default OtherClaims;
